// extracted by mini-css-extract-plugin
export const accordionSection = "accordion-module--accordionSection--2o35y";
export const sectionContainer = "accordion-module--sectionContainer--3yc09";
export const textWrap = "accordion-module--textWrap--15tRC";
export const accordionWrap = "accordion-module--accordionWrap--16AHS";
export const accordionItem = "accordion-module--accordion-item--3huiX";
export const accordionLabel = "accordion-module--accordion-label--28PFn";
export const accordionIcon = "accordion-module--accordionIcon--1G2cz";
export const accordionOpen = "accordion-module--accordionOpen--3LQvf";
export const accordionContent = "accordion-module--accordionContent--1a-Xr";